import {Directive, ElementRef, Input, OnInit} from '@angular/core';

type MatSizeType = 'sm' | 'lg' | 'md';

const MatSizeClassMap = {
  sm: 'mat-size-sm',
  lg: 'mat-size-lg',
  md: 'mat-size-md',
}

@Directive({
  selector: '[nw-mat-size]'
})
export class NewellMatSizeDirective implements OnInit {

  @Input('nw-mat-size') size: MatSizeType;

  constructor(private _el: ElementRef) {}

  ngOnInit() {
    const className = MatSizeClassMap[this.size];
    this._el.nativeElement.classList.add(className);
  }
}


